export default {
  title: 'Dezvoltatori',
  subtitle: 'Chei API, webhook-uri și istoric de livrare pentru integrarea ta cu API-ul pentru parteneri.',
  no_account: 'Niciun cont Partner API încă — contactează Foodamigos pentru a obține unul.',
  no_account_manage: 'Niciun cont Partner API încă — creează unul pentru a emite chei.',
  buttons: {
    new_account: 'Cont nou',
    edit_account: 'Editează contul',
    docs: 'Documentație API',
  },
  tabs: {
    api_keys: 'Chei API',
    webhooks: 'Webhook-uri',
    deliveries: 'Livrări',
  },
  toasts: {
    load_error: 'Conturile tale Partner API nu au putut fi încărcate.',
  },
};
